var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 42V31C29 30.4477 28.5523 30 28 30H20C19.4477 30 19 30.4477 19 31V42",
    stroke: "white",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 22V38C10 39.8856 10 40.8284 10.5858 41.4142C11.1716 42 12.1144 42 14 42H34C35.8856 42 36.8284 42 37.4142 41.4142C38 40.8284 38 39.8856 38 38V22",
    stroke: "white",
    strokeWidth: 1.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.62127 7.51493C9.80316 6.78737 9.8941 6.42359 10.1654 6.21179C10.4366 6 10.8116 6 11.5616 6H36.4384C37.1884 6 37.5634 6 37.8346 6.21179C38.1059 6.42359 38.1968 6.78737 38.3787 7.51493L41.3787 19.5149C41.6647 20.6589 41.8077 21.2308 41.5074 21.6154C41.2072 22 40.6176 22 39.4384 22H37.3885C35.7702 22 34.961 22 34.4015 21.526C33.842 21.0521 33.709 20.2539 33.4429 18.6576L33.1973 17.1837C33.1222 16.7334 33.0847 16.5083 33 16.5083C32.9153 16.5083 32.8778 16.7334 32.8027 17.1837L32.5571 18.6576C32.291 20.2539 32.158 21.0521 31.5985 21.526C31.039 22 30.2298 22 28.6115 22H28.3885C26.7702 22 25.961 22 25.4015 21.526C24.842 21.0521 24.709 20.2539 24.4429 18.6576L24.1973 17.1837C24.1222 16.7334 24.0847 16.5083 24 16.5083C23.9153 16.5083 23.8778 16.7334 23.8027 17.1837L23.5571 18.6576C23.291 20.2539 23.158 21.0521 22.5985 21.526C22.039 22 21.2298 22 19.6115 22H19.3885C17.7702 22 16.961 22 16.4015 21.526C15.842 21.0521 15.709 20.2539 15.4429 18.6576L15.1973 17.1837C15.1222 16.7334 15.0847 16.5083 15 16.5083C14.9153 16.5083 14.8778 16.7334 14.8027 17.1837L14.5571 18.6576C14.291 20.2539 14.158 21.0521 13.5985 21.526C13.039 22 12.2298 22 10.6115 22H8.56155C7.38242 22 6.79285 22 6.49257 21.6154C6.19229 21.2308 6.33529 20.6589 6.62127 19.5149L9.62127 7.51493Z",
    stroke: "white",
    strokeWidth: 1.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShop);
export default __webpack_public_path__ + "static/media/shop.f101547a29b6dbabef692a6429216bee.svg";
export { ForwardRef as ReactComponent };